
export function initialize(): void {
    var skipToContentLink = document.getElementById('skip-to-content');
    var skipToMenuLink = document.getElementById('skip-to-mainmenu');
    var skipToleftMenuLink = document.getElementById('skip-to-leftmenu');
    var skipToRelatedInfoLink = document.getElementById('skip-to-related-info');
    var skipToNotesLink = document.getElementById('skip-to-notes');
    var skipToleftMobileMenuLink = document.getElementById('skip-to-left-mobile-menu');
    var skipToleftDocumentMobileMenuLink = document.getElementById('skip-to-document-mobile-menu');

    var mainArea = document.getElementById('main');
    var mainContent = document.getElementById('main-content');
    var mainMenu = document.getElementById('menubutton');
    var leftMenu = document.getElementById('left-menu');
    var relatedInfoContainer = document.getElementById('notes-show-or-hide');
    var notesContainer = document.getElementById('documentnotes');
    var leftMobileMenu = document.getElementById('mobile-toolbar__open');
    var documentMobileMenu = document.getElementById('document-toggler-btn');

    if (mainContent !== null) {
        skipToContentLink.style.display = 'block';
        skipToContentLink.addEventListener('click', function (event) {
            event.preventDefault();
            mainContent.tabIndex = -1;
            mainContent.focus();
            window.scrollTo({
                top: 0
            });
        });
    } else {
        if (mainArea !== null) {
            skipToContentLink.style.display = 'block';
            skipToContentLink.addEventListener('click', function (event) {
                event.preventDefault();

                mainArea.tabIndex = -1;
                mainArea.focus();
                window.scrollTo({
                    top: 0
                });
            });
        } else {
            skipToContentLink.style.display = 'none';
        }
    }

    if (mainMenu !== null) {
        skipToMenuLink.style.display = 'block';
        skipToMenuLink.addEventListener('click', function (event) {
            event.preventDefault();
            mainMenu.focus();
        });
    } else {
        skipToMenuLink.style.display = 'none';
    }

    if (leftMobileMenu !== null && window.getComputedStyle(leftMobileMenu).display !== "none") {
        skipToleftMobileMenuLink.style.display = 'block';
        skipToleftMobileMenuLink.addEventListener('click', function (event) {
            event.preventDefault();
            leftMobileMenu.focus();
            window.scrollTo({
                top: 0
            });
        });

    } else if (documentMobileMenu !== null && window.getComputedStyle(documentMobileMenu).display !== "none") {
        skipToleftDocumentMobileMenuLink.style.display = 'block';
        skipToleftDocumentMobileMenuLink.addEventListener('click', function (event) {
            event.preventDefault();
            documentMobileMenu.focus();
            window.scrollTo({
                top: 0
            });
        });
    } else {
        if (leftMenu !== null) {
            skipToleftMenuLink.style.display = 'block';
            skipToleftMenuLink.addEventListener('click', function (event) {
                event.preventDefault();
                leftMenu.tabIndex = -1;
                leftMenu.focus();
                window.scrollTo({
                    top: 0
                });
            });
        } else {
            skipToleftMenuLink.style.display = 'none';
        }

        if (relatedInfoContainer !== null) {
            skipToRelatedInfoLink.style.display = 'block';
            skipToRelatedInfoLink.addEventListener('click', function (event) {
                event.preventDefault();
                //setTimeout(() => {
                    //var relatedInfoWrapper = document.getElementById('notesSelectorWrapper');
                    //var firstButton = relatedInfoWrapper.querySelector('button');
                    relatedInfoContainer.tabIndex = -1;
                    relatedInfoContainer.focus();
                    window.scrollTo({
                        top: 0
                    });
                //}, 300);
            });
        } else {
            skipToRelatedInfoLink.style.display = 'none';
        }

        if (notesContainer !== null) {
            skipToNotesLink.style.display = 'block';
            skipToNotesLink.addEventListener('click', function (event) {
                event.preventDefault();
                //setTimeout(() => {
                    //var notesWrapper = document.getElementById('notesSelectorWrapper');
                    //var firstButton = notesWrapper.querySelector('button');
                    notesContainer.tabIndex = -1;
                    notesContainer.focus();
                    window.scrollTo({
                        top: 0
                    });
                //}, 300);
            });
        } else {
            skipToNotesLink.style.display = 'none';
        }
    }
}